export enum OrdemDetalheCampanha {
  Nome_do_Cliente = 0,
  Data_da_Emissão = 1
}
